import { AddressCardStack } from './address-card-stack';
import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { PennywiseAddressCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/address-cards-1x3/pennywise-address-card-stack-background/pennywise-address-card-stack-background.component';
import { PennywiseAddressCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/address-cards-1x3/pennywise-address-card-stack-content/pennywise-address-card-stack-content.component';

export class PennywiseAddressCardStack extends AddressCardStack {
  getCardBackgroundComponent(data: CardData): Type<CardBackgroundComponent> | null {
    return PennywiseAddressCardStackBackgroundComponent;
  }

  getCardContentComponent(data: CardData): Type<PrintCardContentComponent> | null {
    return PennywiseAddressCardStackContentComponent;
  }
}
